import { render } from "./AuditLogView.vue?vue&type=template&id=4748a2be&scoped=true&ts=true"
import script from "./AuditLogView.vue?vue&type=script&lang=ts"
export * from "./AuditLogView.vue?vue&type=script&lang=ts"

import "./AuditLogView.vue?vue&type=style&index=0&id=4748a2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4748a2be"]])

export default __exports__